const KEY = 'platform_has_close_prev'

export default {
  computed: {
    isNeedClosePrev() {
      return (
        this.$platform.isYixinliApp &&
        this.$route.query.closePre == 1 &&
        sessionStorage.getItem(KEY) != 1
      )
    }
  },
  mounted() {
    if (this.isNeedClosePrev) {
      try {
        this.$bridge.call('closePreviousPage', {})
        sessionStorage.setItem(KEY, 1) // 在sessionStorage中记录是否关闭过上一个webview，以免刷新页面时重复执行
        console.info('close pre done!')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
